import { CLASS_ACTIVE } from '../../tools/constants/classes';
import { responsiveMediaBelow } from '../../settings/responsive';

const SELECTOR_STAR_LINK = '[data-product-reviews]';
const SELECTOR_REVIEWS_CONTAINER = '[data-product-reviews]';
const SELECTOR_REVIEWS_TEXTS = '[data-product-reviews-texts]';
const SELECTOR_NAV_NEXT = '[data-carousel-next]';
const SELECTOR_NAV_PREV = '[data-carousel-previous]';
const SELECTOR_REVIEW_TEXT = '[data-review-text]';

const link = document.querySelector(SELECTOR_STAR_LINK);

if (link) {
  link.addEventListener('click', (evt) => {
    const reviewsContainer = document.querySelector(SELECTOR_REVIEWS_CONTAINER);
    if (!reviewsContainer) return;
    evt.preventDefault();
    reviewsContainer.scrollIntoView({
      behavior: 'smooth',
    });
  });
}

document.querySelectorAll(SELECTOR_REVIEWS_CONTAINER).forEach((container) => {
  const reviewsTextsContainer = container.querySelector(SELECTOR_REVIEWS_TEXTS);
  const reviewsTexts = container.querySelectorAll(SELECTOR_REVIEW_TEXT);
  const nextArrow = container.querySelector(SELECTOR_NAV_NEXT);
  const prevArrow = container.querySelector(SELECTOR_NAV_PREV);

  if (!nextArrow || !prevArrow || !reviewsTextsContainer || !reviewsTexts)
    return;

  const navigateTexts = (nav: 'next' | 'prev') => {
    if (responsiveMediaBelow('MEDIUM')) return;

    const lastActiveSlide = reviewsTextsContainer.querySelector(
      `.${CLASS_ACTIVE}`
    );
    if (!lastActiveSlide) return;

    const nextSibling = lastActiveSlide.nextElementSibling;
    const prevSibling = lastActiveSlide.previousElementSibling;
    const firstSibling = reviewsTexts[0];
    const lastSibling = reviewsTexts[reviewsTexts.length - 1];

    reviewsTexts.forEach((text) => text.classList.remove(CLASS_ACTIVE));

    if (nav === 'next') {
      if (nextSibling) {
        nextSibling.classList.add(CLASS_ACTIVE);
      } else {
        firstSibling.classList.add(CLASS_ACTIVE);
      }
    } else if (prevSibling) {
      prevSibling.classList.add(CLASS_ACTIVE);
    } else {
      lastSibling.classList.add(CLASS_ACTIVE);
    }
  };

  nextArrow.addEventListener('click', () => {
    navigateTexts('next');
  });
  prevArrow.addEventListener('click', () => {
    navigateTexts('prev');
  });
});

// calculate size and set reviews images container width
function calculateSizePhotos() {
  const width = screen.width;
  const photo = document.querySelectorAll<HTMLElement>(
    '.stamped-photos-carousel .photo'
  );

  photo.forEach((photo) => {
    const photoWidth = photo.offsetWidth;
    if (width <= 750) {
      photo.style.height = `${photoWidth}px`;
    }
  });
}

window.addEventListener('resize', calculateSizePhotos);
window.addEventListener('load', calculateSizePhotos);

function filterReviews() {
  const filterReviewsSelectEL = document.querySelector<HTMLElement>(
    '.stamped-reviews-filter-label'
  );
  const filterReviewsContainerEL = document.querySelector<HTMLElement>(
    '.stamped-summary-keywords'
  );
  const filterSelectsContainerEL = document.querySelectorAll<HTMLElement>(
    '.stamped-filter-selects .stamped-filter-select'
  );
  const sortSelectorEl = document.querySelector<HTMLElement>(
    '.stamped-sort-select2-wrapper select'
  );

  function openSelect() {
    filterReviewsContainerEL?.classList.toggle('active');
    if (filterSelectsContainerEL.length === 0) {
      filterReviewsContainerEL?.setAttribute('style', 'top:90px;');
    }
  }

  filterReviewsSelectEL?.addEventListener('click', () => {
    openSelect();
  });
}

window.addEventListener('load', filterReviews);

function readMore() {
  const readMoreBtn = document.querySelector<HTMLElement>(
    '[data-read-more-link]'
  );
  const readMoreText = document.querySelector<HTMLElement>(
    '[data-read-more-content]'
  );
  const readMoreBtnLess = document.querySelector<HTMLElement>(
    '[data-read-less-link]'
  );
  const topOffset = readMoreBtn?.offsetTop;

  readMoreBtnLess?.addEventListener('click', () => {
    readMoreText?.classList.toggle('active');
    readMoreBtn?.classList.toggle('active');

    window.scrollTo({
      top: topOffset && topOffset - 100,
      // behavior: 'smooth'
    });
  });

  readMoreBtn?.addEventListener('click', () => {
    readMoreText?.classList.toggle('active');
    readMoreBtn?.classList.toggle('active');
  });
}

readMore();
